/**
 * @author vishwadeep.kapoor
 * @Date: 2019-06-11 13:16:31
 * @Last Modified by: vishwadeep
 * @Last Modified time: 2019-06-11 13:16:31
 */

import * as reqHandler from '../../config/services/serviceHandler';
import endpoint from '../../config/endPoints';
import { rootApiResponse, clearDefaultError } from '../HeaderContainer/actions';
import { utils, eventTracking } from '../../devUtils';

import { DEFAULT_ACTION, UPDATE_PASSWORD_SUCCESS } from './constants';
// const defaultAction = (payload = true) => ({ type: DEFAULT_ACTION, payload });

const successActionData = (payload) => ({ type: UPDATE_PASSWORD_SUCCESS, payload });

export const updatePassword = (payload) => async (dispatch, getState, api) => {
  try {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION, true));
    dispatch(clearDefaultError());
    const response = await reqHandler.postHandler(api, endpoint.RESET_PASSWORD, payload, { isPlainJS: true });
    // const response = { message: 'success' };
    if (response.message) {
      dispatch(utils.isReducerLoading(DEFAULT_ACTION));
      dispatch(successActionData(response));
      dispatch(rootApiResponse(utils.successResponse(DEFAULT_ACTION, response.message)));
      eventTracking.triggerEvent('Login', 'Set password confirm', 'Success');
    }
  } catch (err) {
    dispatch(utils.isReducerLoading(DEFAULT_ACTION));
    dispatch(rootApiResponse(utils.errorResponse(DEFAULT_ACTION, err)));
    eventTracking.triggerEvent('Login', 'Set password confirm', 'Failure');
  }
};



// WEBPACK FOOTER //
// client/containers/EmailVerification/actions.js